export const lessThanYearLeft = (givenDate: Date): boolean => {
  const currentDate = new Date()
  const difference = givenDate.getTime() - currentDate.getTime()
  const yearInMs = 31536000000

  return difference < yearInMs
}
